import "./style/main.scss";

import home from "./js/pages/home.js";
import reviews from "./js/pages/reviews.js";
import rooms from "./js/pages/rooms.js";
import gallery from "./js/pages/gallery";
import host from "./js/pages/host.js";
import booknow from "./js/pages/booknow";
import nav from "./js/components/nav";
// check if in oxygen builder

function init() {
  nav();
  if (document.querySelector(".main-hero")) {
    home();
  }
  if (document.querySelector(".reviews-hero")) {
    reviews();
  }
  if (document.querySelector(".hero-room")) {
    rooms();
  }


  if (document.querySelector(".gallery-hero")) {
    gallery();
  }

  if (document.querySelector(".host-hero-section")) {
    host();
  }
  if (document.querySelector(".book-now__hero")) {
    booknow();
  }
}

init();
